import configDefault from "./config-default";

const config = {
  ...configDefault,
  code: "wakeupform",
  favicon: '/wakeupform/wakeupform-favicon.png',
  companyName: "WakeUpForm",
  website: 'https://www.wakeupform.fr/',
  notifyChannel: 'vel-wakeupform',
  htmlCustomCSS: "wakeupform.scss",
  header: {
    title: '',
    logo: '/wakeupform/wakeupform-logo.png'
  },
  plans: {
		...configDefault.plans,
		useImg : 'withoutText', // img full size in the Choice card, not text
    topOfferTitle: 'Offre du moment',
    feesLabelComplement: "(comprenant le Kit de bienvenue WUF)",
  },
  options: {
    title: "Choisissez vos options",
    message: "",
    nextLabel: "Suivant",
  },
  steps: {
    ...configDefault.steps,
    userForm: {
      ...configDefault.steps.userForm,
      optins: {
        ...configDefault.steps.userForm.optins,
				acceptLegal: {
					...configDefault.steps.userForm.optins.acceptLegal,
					text: "J’ai lu et j'accepte les conditions générales",
          moreLabel: "Voir les CGV",
					href: 'https://www.wakeupform.fr/conditions-generales-dadhesion/',
          required: true
				},
				acceptAdvertising: {
					...configDefault.steps.userForm.optins.acceptAdvertising,
					text: "J’accepte de recevoir par e-mail des informations juridiques ou commerciales et relatives aux actualités de WakeupForm",
				},
			}
    }
  },
  footer: {
    logo: '/wakeupform/wakeupform-logo.png',
    textLine: 'Révèle toi!',
    cgv: {
      link: 'https://www.wakeupform.fr/conditions-generales-dadhesion/',
      text: 'CGV'
    }
  }
};

export default config;
